import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ChainAuditService } from "@app/features/chain-audit/chain-audit.service";

@Component({
    selector: 'app-chain-audit',
    templateUrl: './chain-audit.component.html',
    styleUrls: ['./chain-audit.component.scss'],
    standalone: false
})
export class ChainAuditComponent implements OnInit {

  @ViewChild('chainAuditTable') chainAuditTable: MatTable<any>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  audits = [];
  auditDisplayColumns = ['storeNumber', 'firmware', 'model'];
  auditDataSource = new MatTableDataSource<any>(this.audits);
  isLoading: boolean = false;
  filterText: string = null;

  constructor(private auditService: ChainAuditService) { }

  ngOnInit() {
    this.getChainAudit();
  }

  getChainAudit() {
    this.isLoading = true;
    return this.auditService.getChainAudit().then((observable) => {
      observable.toPromise().then((response) => {
        let data = this.formatData(response["message"]);
        this.auditDataSource.data = data;
        this.auditDataSource.paginator = this.paginator;
        this.auditDataSource.sort = this.sort;
        this.chainAuditTable.renderRows();
        this.isLoading = false;
      });
    });
  }

  formatData(audits) {
    let formattedData = []
    for (let storeNumber in audits) {
      let data = {"storeNumber": storeNumber,};
      if (audits[storeNumber].hasOwnProperty("firmware")) {
        data["firmware"] = audits[storeNumber]["firmware"];
      } else {
        data["firmware"] = [];
      }
      if (audits[storeNumber].hasOwnProperty("model")) {
        data["model"] = audits[storeNumber]["model"];
      } else {
        data["model"] = [];
      }
      formattedData.push(data);
    }
    return formattedData;
  }

  applyFilter(filterValue: string) {
    this.auditDataSource.filterPredicate = (data: any, filter: string) => {
      let containsFilterValue: boolean = false;
      if (filter == "null" || data["storeNumber"].includes(filterValue)) {
        containsFilterValue = true;
      }
      return containsFilterValue;
    }
    // handles cases where no filter text is provided
    if (filterValue == null || filterValue == "") {
      this.auditDataSource.filter = "null";
    } else {
      this.auditDataSource.filter = filterValue.trim().toLowerCase();
    }
  }
}